import { __awaiter } from "tslib";
import React from 'react';
import { createModule } from '../module';
import { XFlowAppExtensionModule, useExtensionRegistry, insertCss } from '@antv/xflow-core';
export const CONFIG_TYPE = 'CanvasSnapline';
/** 默认颜色 */
export const SNAPLINE_COLOR = '#faad14';
export const CanvasSnapline = props => {
    const { color = SNAPLINE_COLOR } = props;
    const extension = useExtensionRegistry();
    const config = React.useMemo(() => ({
        CONFIG_TYPE,
        getConfig: () => __awaiter(void 0, void 0, void 0, function* () { return ({}); }),
    }), []);
    /** 设置css 样式 */
    React.useEffect(() => {
        const className = `xflow-snapline-${Date.now()}`;
        // 多xflow之间隔离
        extension.addContainerClassNames(className);
        const cssString = `
    .${className} .xflow-snapline .x6-widget-snapline-horizontal,
    .${className} .xflow-snapline .x6-widget-snapline-vertical {
      border-color: ${color};
    }`;
        const $style = insertCss(cssString);
        return () => {
            document.head.removeChild($style);
        };
    }, [color, extension]);
    return React.createElement(XFlowAppExtensionModule, { config: config, createModule: createModule });
};
//# sourceMappingURL=index.js.map